import { render, staticRenderFns } from "./TypeTable.vue?vue&type=template&id=a2e3af7a"
import script from "./TypeTable.vue?vue&type=script&lang=js"
export * from "./TypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2e3af7a')) {
      api.createRecord('a2e3af7a', component.options)
    } else {
      api.reload('a2e3af7a', component.options)
    }
    module.hot.accept("./TypeTable.vue?vue&type=template&id=a2e3af7a", function () {
      api.rerender('a2e3af7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/TypeTable.vue"
export default component.exports